import { fabric } from 'fabric';

export interface ObjectCoords {
  tl_x: number;
  tl_y: number;
  br_x: number;
  br_y: number;
}

export function isObjectInCanvasViewport(canvas: fabric.Canvas, objCoords: ObjectCoords): boolean {
  const zoom = canvas.getZoom();
  const vptCoords = canvas.vptCoords;
  const canvasWidth = canvas.width;

  if (!zoom || !canvasWidth || !vptCoords) {
    return false;
  }

  // vpt coords
  const { top, bottom, left, right } = {
    bottom: vptCoords.bl.y,
    left: vptCoords.bl.x,
    top: vptCoords.tr.y,
    right: vptCoords.bl.x + canvasWidth / zoom,
  };

  // object coords
  const objectBoundingRect = {
    bottom: objCoords.br_y,
    left: objCoords.tl_x,
    top: objCoords.tl_y,
    right: objCoords.br_x,
  };

  // Check if the object is not fully outside the viewport
  return !(
    objectBoundingRect.top > bottom ||
    objectBoundingRect.bottom < top ||
    objectBoundingRect.left > right ||
    objectBoundingRect.right < left
  );
}
